export default {
  app: {
    title: '棲雲數坊',
    subtitle: '基於貝殼網的租房數據爬取和分析平台',
    footer: '© {year} 棲雲數坊 · 基於Vue.js和FastAPI開發 · 版權所有'
  },
  menu: {
    home: '首頁',
    tasks: '爬蟲任務',
    ipManagement: 'IP管理',
    scheduledTasks: '定時任務',
    houses: '房源數據',
    analysis: '數據分析',
    settings: '系統設置'
  },
  home: {
    systemIntro: '系統功能介紹',
    introText: '本系統是一個基於Python技術棧開發的租房數據分析平台，通過爬取貝殼網的租房信息，並使用PySpark進行數據處理和分析，最終以可視化圖表的形式展示市場洞察。',
    mainFeatures: '主要功能:',
    dataCollection: '數據採集',
    dataCollectionDesc: '支持多城市租房數據爬取，自動解析房源價格、面積、位置等關鍵信息',
    dataAnalysis: '數據分析',
    dataAnalysisDesc: '使用PySpark對租房數據進行多維度分析，包括區域分析、戶型分析、價格分佈等',
    visualization: '可視化展示',
    visualizationDesc: '通過ECharts圖表直觀展示分析結果，幫助用戶快速了解租房市場情況',
    quickStart: '快速開始:',
    step1: '在右側創建新的爬蟲任務，選擇城市和爬取頁數',
    step2: '等待爬蟲任務完成後，在任務列表中查看詳情',
    step3: '點擊"查看數據"瀏覽爬取的房源信息，或點擊"分析數據"進行數據分析',
    step4: '在數據分析頁面查看生成的可視化圖表',
    createTask: '創建新爬蟲任務',
    viewAnalysis: '查看分析',
    step1Title: '創建任務',
    step2Title: '查看結果',
    step3Title: '分析數據',
    city: '城市',
    selectCity: '請選擇城市',
    crawlPages: '爬取頁數',
    startCrawling: '開始爬取',
    reset: '重置',
    recentTasks: '最近爬蟲任務',
    viewAll: '查看全部',
    noTasks: '暫無爬蟲任務',
    status: '狀態:',
    startTime: '開始時間:',
    houseCount: '房源數:',
    view: '查看',
    taskStatus: {
      inProgress: '進行中',
      completed: '完成',
      failed: '失敗'
    },
    fetchTasksFailed: '獲取最近任務失敗',
    taskCreatedSuccess: '成功創建爬蟲任務',
    请设置爬取页数: '請設置爬取頁數',
    爬虫任务创建成功: '爬蟲任務創建成功'
  },
  notFound: '頁面未找到',
  nav: {
    home: '首頁',
    taskList: '任務列表',
    scheduledTasks: '定時任務',
    scheduledtasks: '定時任務',
    ipManagement: 'IP管理',
    houseList: '房源列表',
    analysis: '數據分析',
    userprofile: '個人資料',
    usersettings: '賬戶設置',
    systemsettings: '系統設置'
  },
  auth: {
    login: '登錄',
    register: '註冊',
    forgotPassword: '忘記密碼',
    forgotPasswordTitle: '找回密碼',
    forgotPasswordSubtitle: '輸入您的郵箱地址，我們將發送驗證碼',
    sendResetLink: '發送重置鏈接',
    sendVerificationCode: '發送驗證碼',
    resetPasswordTitle: '重置密碼',
    resetPasswordSubtitle: '請輸入驗證碼和新密碼',
    verificationCode: '驗證碼',
    newPassword: '新密碼',
    confirmNewPassword: '確認新密碼',
    resendCode: '重新發送驗證碼',
    rememberedPassword: '想起密碼了?',
    registerTitle: '創建新賬戶',
    registerSubtitle: '填寫以下信息完成註冊',
    loginTitle: '歡迎回來',
    loginSubtitle: '請登錄您的賬戶',
    username: '用戶名',
    email: '郵箱',
    password: '密碼',
    confirmPassword: '確認密碼',
    rememberMe: '記住我',
    forgotYourPassword: '忘記密碼?',
    noAccount: '還沒有賬戶?',
    alreadyHaveAccount: '已有賬戶?',
    agreeTerms: '我同意服務條款和隱私政策',
    termsLink: '服務條款',
    haveAccount: '已有賬戶?',
    createAccount: '創建賬戶',
    resetPassword: '重置密碼'
  },
  user: {
    profile: '個人資料',
    profileDesc: '查看和編輯您的個人信息',
    settings: '賬戶設置',
    settingsDesc: '管理您的賬戶設置和偏好',
    logout: '退出登錄',
    username: '用戶名',
    email: '郵箱',
    changePassword: '修改密碼',
    currentPassword: '當前密碼',
    currentPasswordPlaceholder: '請輸入當前密碼',
    newPassword: '新密碼',
    newPasswordPlaceholder: '請輸入新密碼',
    confirmNewPassword: '確認新密碼',
    confirmPasswordPlaceholder: '請再次輸入新密碼',
    saveChanges: '保存更改',
    changeAvatar: '更換頭像',
    deleteAccount: '刪除賬戶',
    deleteAccountConfirmation: '確認刪除賬戶',
    deleteAccountWarning: '警告：此操作將永久刪除您的賬戶和所有相關數據，且無法恢復。',
    deleteConfirmation: '確認',
    deleteConfirmationPlaceholder: '請輸入DELETE確認刪除',
    passwordRequired: '請輸入密碼',
    confirmationRequired: '請輸入確認文本',
    password: '密碼',
    passwordPlaceholder: '請輸入密碼',
    notificationSettings: '通知設置',
    emailNotifications: '郵件通知',
    emailNotificationsDesc: '接收系統相關更新和重要通知的郵件',
    taskCompletionNotifications: '任務完成通知',
    taskCompletionNotificationsDesc: '當爬蟲任務完成時接收通知',
    displaySettings: '顯示設置',
    language: '語言',
    theme: '主題',
    themeLight: '淺色',
    themeDark: '深色',
    themeSystem: '跟隨系統',
    themeDesc: '選擇應用的顯示主題',
    accountSettings: '賬戶設置',
    dataSharing: '數據共享',
    dataSharingDesc: '允許系統收集匿名使用數據以改進服務',
    dangerZone: '危險區域',
    dangerZoneDesc: '以下操作可能會導致不可逆的數據丟失'
  },
  settings: {
    systemSettings: '系統設置',
    systemSettingsDesc: '管理系統整體設置和配置',
    databaseSettings: '資料庫設置',
    databaseConfig: '資料庫配置',
    dataManagement: '資料管理',
    systemInfo: '系統資訊',
    systemStatus: '系統狀態',
    about: '關於',
    
    dbHost: '主機地址',
    dbPort: '連接埠',
    dbName: '資料庫名',
    dbUser: '使用者名',
    dbPassword: '密碼',
    
    purgeData: '清除資料',
    purgeDataDesc: '刪除所有爬取的房源資料和任務記錄',
    purgeDataConfirmation: '確認清除資料',
    purgeDataWarning: '此操作將永久刪除所有房源資料和任務記錄，且無法恢復。',
    purgeConfirmation: '我已了解風險，確認清除所有資料',
    
    exportData: '匯出資料',
    exportDataDesc: '匯出所有系統設置和配置資料',
    
    version: '版本',
    lastUpdate: '最後更新',
    apiStatus: 'API狀態',
    dbStatus: '資料庫狀態',
    userCount: '使用者數',
    houseCount: '房源數',
    taskCount: '任務數',
    startupTime: '啟動時間',
    uptime: '運行時間',
    diskUsage: '磁碟使用',
    
    adminOnlyNotice: '只有管理員可以修改資料庫設置',
    resetToDefault: '重置為預設值',
    saveChanges: '儲存更改',
    
    aboutText: '這是一個基於Vue.js和FastAPI開發的租房數據分析系統，能夠爬取、儲存和分析租房數據。',
    sourceCode: '原始碼',
    documentation: '文檔',
    reportBug: '報告問題'
  },
  scheduledTasks: {
    title: '定時任務',
    createTask: '創建任務',
    editTask: '編輯任務',
    taskName: '任務名稱',
    city: '城市',
    selectCity: '請選擇城市',
    pagesToCrawl: '爬取頁數',
    schedule: '執行計劃',
    nextRun: '下次執行時間',
    status: '狀態',
    actions: '操作',
    runTime: '執行時間',
    weekday: '星期',
    monthDay: '日期',
    daily: '每天',
    weekly: '每週',
    monthly: '每月',
    monday: '星期一',
    tuesday: '星期二',
    wednesday: '星期三',
    thursday: '星期四',
    friday: '星期五',
    saturday: '星期六',
    sunday: '星期日',
    nameRequired: '請輸入任務名稱',
    nameLength: '長度在2到100個字符',
    cityRequired: '請選擇城市',
    pagesRequired: '請輸入爬取頁數',
    pagesRange: '頁數必須在1到100之間',
    timeRequired: '請選擇執行時間',
    warning: '警告',
    confirm: '確認',
    cancel: '取消',
    confirmDeleteTask: '確定要刪除定時任務 {name} 嗎？',
    deleteSuccess: '刪除成功',
    deleteError: '刪除失敗',
    createSuccess: '創建成功',
    updateSuccess: '更新成功',
    saveError: '保存失敗',
    fetchTasksError: '獲取任務列表失敗',
    fetchCitiesError: '獲取城市列表失敗',
    everyDayAt: '每天 {time}',
    everyWeekAt: '每週{day} {time}',
    everyMonthAt: '每月{day}日 {time}'
  },
  cancel: '取消',
  ipManagement: {
    currentIp: '當前IP地址',
    refreshIp: '刷新IP',
    proxyPool: '代理IP池',
    ipSettings: 'IP設置',
    addProxy: '添加代理',
    ipAddress: 'IP地址',
    port: '端口',
    location: '位置',
    status: '狀態',
    latency: '延遲',
    lastUsed: '最後使用時間',
    actions: '操作',
    test: '測試',
    delete: '刪除',
    rotationStrategy: 'IP輪換策略',
    rotationInterval: '輪換間隔',
    maxFailures: '最大失敗次數',
    autoAddProxies: '自動添加代理',
    minutes: '分鐘',
    failures: '次',
    saveSettings: '保存設置',
    resetSettings: '重置設置',
    username: '用戶名',
    password: '密碼',
    strategies: {
      manual: '手動切換',
      time: '定時輪換',
      failure: '失敗後輪換',
      request: '請求數達到後輪換'
    },
    statusTypes: {
      active: '可用',
      inactive: '不可用',
      error: '錯誤'
    }
  },
  common: {
    confirm: '確定',
    cancel: '取消',
    save: '保存',
    delete: '刪除'
  },
  taskList: {
    title: '爬蟲任務列表',
    refresh: '刷新',
    status: {
      inProgress: '進行中',
      completed: '完成',
      failed: '失敗'
    },
    messages: {
      taskInProgress: '爬蟲任務進行中，暫無法查看數據',
      cannotAnalyzeInProgress: '爬蟲任務進行中，暫無法分析數據',
      noDataToAnalyze: '沒有成功爬取的數據，無法進行分析',
      analysisStarted: '數據分析任務已啟動',
      analysisStartFailed: '啟動數據分析任務失敗',
      cannotDeleteInProgress: '爬蟲任務進行中，無法刪除',
      confirmDelete: '確定要刪除ID為{id}的{city}爬蟲任務嗎？此操作將刪除任務及相關數據，且不可恢復。',
      deleteConfirmTitle: '刪除確認',
      deleteSuccess: '任務刪除成功',
      deleteFailed: '刪除任務失敗',
      fetchTasksFailed: '獲取任務列表失敗'
    },
    columns: {
      id: 'ID',
      city: '城市',
      status: '狀態',
      startTime: '開始時間',
      endTime: '結束時間',
      totalItems: '總條目',
      successItems: '成功條目',
      progress: '進度',
      actions: '操作'
    },
    crawlerRunning: '爬蟲任務正在初始化',
    waitForCrawler: '爬蟲任務剛剛啟動，數據庫正在處理中，請稍後再查看任務列表',
    remainingTime: '預計剩餘時間',
    viewAnyway: '仍然查看'
  }
}; 